import { SyncCoreDataDefinitionsEnumTranslator } from '@edgebox/sync-core-data-definitions';

/**
 * The word the definitions package gives an enum value, or the fallback when it has none.
 *
 * Every caller is a render path — a screen, and a frame a site's own visitors read — and both ways
 * the package can answer for a value it does not know end there. An enum it no longer declares makes
 * the translator throw, which takes the whole screen down; a member it has no word for comes back
 * absent while the signature says a word, which puts nothing where a person expects one. This app and
 * the package are a version apart whenever one ships ahead of the other, so both reach a person.
 *
 * The fallback answers all of it, and an absent value takes it without asking the package, because
 * nothing was sent rather than something it could not translate.
 */
export function translateEnumSafe(
  enumName: 'ContentPriority' | 'ContentItemStatus' | 'ContentWorkflowState',
  value: unknown,
  fallback = '-'
): string {
  if (value === undefined || value === null || value === '') {
    return fallback;
  }

  let word: unknown;
  try {
    word = SyncCoreDataDefinitionsEnumTranslator.transLateEnumValue(enumName, value as never);
  } catch {
    return fallback;
  }

  return typeof word === 'string' && word.length > 0 ? word : fallback;
}
